<template>
  <Loading v-if="loading" />
  <DialogBox v-else title="Excluir Usuário" @close="$emit('close')">
    <template>
      <legend>
       {{is_pt_br ? 'Deseja excluir o usuária' : 'Want delete user'}} {{ name }} ?
      </legend>
    </template>
    <template v-slot:footer>
      <button
        @click.prevent="handleDelete3D"
        class="w-100 mt-1 btn btn-outline-danger"
      >
        {{is_pt_br ? 'Excluir' : 'Delete'}}
      </button>
    </template>
  </DialogBox>
</template>

<script>
import DialogBox from "../utils/DialogBox.vue";
import Loading from "../utils/AnimateLoad.vue";
import { mapActions } from "vuex";
export default {
  name: "DeleteUser",
  props: { user_id: Number, name: String },
  data() {
    return {
      loading: false,
    };
  },
  components: { DialogBox, Loading },
  computed: {
    is_pt_br(){
      return this.$store.getters.is_pt_br
    }
  },
  methods: {
    ...mapActions("user", ["deleteUser"]),
    async handleDelete3D() {
      this.loading = true;
      await this.deleteUser(this.user_id)
      .then((res) => {
        this.$emit("deleted", null);
      })
      .catch(error => { 
        this.$emit("deleted", error)
        })

      this.loading = false;
    },
  },
};
</script>
